"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getQuickFactFixedAPRWithAnnotation = exports.getQuickFactFixedAPR = void 0;
Object.defineProperty(exports, "getQuickFactMinCreditScore", {
  enumerable: true,
  get: function get() {
    return _educationLoans.getDriverMinCreditScore;
  }
});
exports.getQuickFactVariableAPRWithAnnotation = exports.getQuickFactVariableAPR = void 0;
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _educationLoans = require("@nerdwallet/marketplace/drivers/education-loans");
var _excluded = ["UNSAFE_valueTooltip"],
  _excluded2 = ["UNSAFE_valueTooltip"],
  _excluded3 = ["UNSAFE_valueTooltip"],
  _excluded4 = ["UNSAFE_valueTooltip"];
/* eslint-disable react/no-danger */
/**
 * Convert UNSAFE_valueTooltip (disclaimer) to a react component.
 */
var getQuickFactFixedAPR = function getQuickFactFixedAPR(offer) {
  var _getDriverFixedApr = (0, _educationLoans.getDriverFixedApr)(offer),
    valueTooltip = _getDriverFixedApr.UNSAFE_valueTooltip,
    driver = (0, _objectWithoutProperties2.default)(_getDriverFixedApr, _excluded);
  return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, driver), {}, {
    valueTooltip: valueTooltip ? /*#__PURE__*/_react.default.createElement("div", {
      dangerouslySetInnerHTML: {
        __html: valueTooltip
      }
    }) : null
  });
};

/**
 * Convert UNSAFE_valueTooltip (fixed_apr_annotation) to a react component.
 */
exports.getQuickFactFixedAPR = getQuickFactFixedAPR;
var getQuickFactFixedAPRWithAnnotation = function getQuickFactFixedAPRWithAnnotation(offer) {
  var _getDriverFixedAprWit = (0, _educationLoans.getDriverFixedAprWithAnnotation)(offer),
    valueTooltip = _getDriverFixedAprWit.UNSAFE_valueTooltip,
    driver = (0, _objectWithoutProperties2.default)(_getDriverFixedAprWit, _excluded2);
  return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, driver), {}, {
    valueTooltip: valueTooltip ? /*#__PURE__*/_react.default.createElement("div", {
      dangerouslySetInnerHTML: {
        __html: valueTooltip
      }
    }) : null
  });
};

/**
 * Convert UNSAFE_valueTooltip (disclaimer) to a react component.
 */
exports.getQuickFactFixedAPRWithAnnotation = getQuickFactFixedAPRWithAnnotation;
var getQuickFactVariableAPR = function getQuickFactVariableAPR(offer) {
  var _getDriverVariableApr = (0, _educationLoans.getDriverVariableApr)(offer),
    valueTooltip = _getDriverVariableApr.UNSAFE_valueTooltip,
    driver = (0, _objectWithoutProperties2.default)(_getDriverVariableApr, _excluded3);
  return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, driver), {}, {
    valueTooltip: valueTooltip ? /*#__PURE__*/_react.default.createElement("div", {
      dangerouslySetInnerHTML: {
        __html: valueTooltip
      }
    }) : null
  });
};

/**
 * Convert UNSAFE_valueTooltip (variable_apr_annotation) to a react component.
 */
exports.getQuickFactVariableAPR = getQuickFactVariableAPR;
var getQuickFactVariableAPRWithAnnotation = function getQuickFactVariableAPRWithAnnotation(offer) {
  var _getDriverVariableApr2 = (0, _educationLoans.getDriverVariableAprWithAnnotation)(offer),
    valueTooltip = _getDriverVariableApr2.UNSAFE_valueTooltip,
    driver = (0, _objectWithoutProperties2.default)(_getDriverVariableApr2, _excluded4);
  return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, driver), {}, {
    valueTooltip: valueTooltip ? /*#__PURE__*/_react.default.createElement("div", {
      dangerouslySetInnerHTML: {
        __html: valueTooltip
      }
    }) : null
  });
};

/**
 * Preserve exports for backwards compatibility.
 * @deprecated - Leverage exports from `@nerdwallet/marketplace/drivers/education-loans` directly.
 */
exports.getQuickFactVariableAPRWithAnnotation = getQuickFactVariableAPRWithAnnotation;